type LogoProps = {
  size?: number;
  withSparkle?: boolean;
  className?: string;
};

export function Logo({ size = 32, withSparkle = true, className }: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Stockuj"
    >
      <rect width="200" height="200" rx="44" fill="#0A1F44" />
      <text
        x="100"
        y="158"
        textAnchor="middle"
        fontFamily="Geist, system-ui, sans-serif"
        fontWeight="800"
        fontSize="170"
        letterSpacing="-8"
        fill="#F8F9FB"
      >
        S
      </text>
      {withSparkle && (
        <path
          d="M 160 45 L 165 62 L 182 67 L 165 72 L 160 89 L 155 72 L 138 67 L 155 62 Z"
          fill="#93B5FF"
        />
      )}
    </svg>
  );
}
